import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Détection alcool / tabac / promo — porté depuis l'app mobile (mêmes règles Vaud/Fribourg).
const WINE_KEYWORDS = ["vin","wine","champagne","prosecco","cava","crémant","mousseux","rouge","blanc","rosé","pinot","chardonnay","merlot","cabernet","sauvignon","syrah","gamay","chasselas","riesling","gewurztraminer"];
export const BEER_SPIRITS_KEYWORDS = ["bière","biere","beer","lager","ale","stout","pilsner","ipa","whisky","whiskey","vodka","rhum","rum","gin","tequila","cognac","brandy","liqueur","schnaps","absinthe","pastis","ricard","pernod","jagermeister","baileys","amaretto","grappa","calvados","armagnac","heineken","corona","budweiser","stella","jupiler","leffe","grimbergen","feldschlösschen","cardinal","eichhof","calanda","chopfab","boxer","super bock","desperados","apéritif","aperol","campari","martini","vermouth","spritz","alcool","alcohol","spiritueux","spirits","shot","shooter"];
const TOBACCO_KEYWORDS = ["tabac","tobacco","cigarette","cigare","cigar","marlboro","camel","lucky strike","winston","parliament","parisienne","gauloises","vape","e-cigarette","iqos","heets","puff","chicha","shisha","narguilé","hookah"];

export const detectAlcoholType = (title, kw) => {
  const t = `${title} ${kw || ""}`.toLowerCase();
  if (WINE_KEYWORDS.some((k) => t.includes(k))) return "wine";
  if (BEER_SPIRITS_KEYWORDS.some((k) => t.includes(k))) return "beer_spirits";
  return null;
};
export const isTobaccoProduct = (title, kw) => {
  const t = `${title} ${kw || ""}`.toLowerCase();
  return TOBACCO_KEYWORDS.some((k) => t.includes(k));
};
export const calculateAge = (birthDate) => {
  const today = new Date();
  const b = new Date(birthDate);
  let age = today.getFullYear() - b.getFullYear();
  const m = today.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < b.getDate())) age--;
  return age;
};

// RÈGLE PRODUIT : AUCUNE promo automatique. Promotions = uniquement celles configurées par le
// Founder/partenaire sur l'article (promoKind). Détection legacy par mots-clés NEUTRALISÉE (false).
export const isPromoEligible = () => false;

// Remise FORMULE par produit, pilotée UNIQUEMENT par la promo configurée (promoKind) sur l'article
// (second_50 : 1 sur 2 à -50% ; bogo : 1 sur 2 offerte). Rien d'automatique. Backend autoritaire.
export const computeConfiguredPromo = (items) => {
  let discount = 0;
  const lines = [];
  (items || []).forEach((it) => {
    const pairs = Math.floor((it.quantity || 0) / 2);
    if (pairs <= 0 || !it.promoKind) return;
    let amount = 0;
    if (it.promoKind === "second_50") amount = pairs * it.price * 0.5;
    else if (it.promoKind === "bogo") amount = pairs * it.price;
    if (amount > 0) {
      discount += amount;
      lines.push({ id: it.id, title: it.title, label: it.promoLabel || (it.promoKind === "second_50" ? "2ᵉ à -50%" : "1 acheté = 1 offert"), amount: Math.round(amount * 100) / 100 });
    }
  });
  return { discount: Math.round(discount * 100) / 100, lines };
};

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      tip: 0,
      customerBirthDate: null,

      addItem: (item) => {
        const alcoholType = detectAlcoholType(item.title, item.collectionKeywords);
        const flagged = { ...item, isAlcohol: alcoholType !== null, alcoholType, isTobacco: isTobaccoProduct(item.title, item.collectionKeywords) };
        set((state) => {
          const existing = state.items.find((i) => i.id === item.id);
          if (existing) {
            return { items: state.items.map((i) => (i.id === item.id ? { ...i, quantity: i.quantity + (item.quantity || 1) } : i)) };
          }
          return { items: [...state.items, { ...flagged, quantity: item.quantity || 1 }] };
        });
      },
      removeItem: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
      updateQuantity: (id, quantity) =>
        set((s) => ({ items: s.items.map((i) => (i.id === id ? { ...i, quantity: Math.max(0, quantity) } : i)).filter((i) => i.quantity > 0) })),
      clearCart: () => set({ items: [], tip: 0 }),
      setTip: (amount) => set({ tip: amount }),
      setCustomerBirthDate: (date) => set({ customerBirthDate: date }),

      getTotalWithPromo: () => {
        const items = get().items;
        const subtotal = items.reduce((t, i) => t + i.price * i.quantity, 0);
        // Les remises (2e à -50 %, codes promo) sont calculées côté serveur (/api/cart/quote).
        return { subtotal, promoDiscount: 0, total: subtotal };
      },
      getTotal: () => { const { total } = get().getTotalWithPromo(); return total; },
      getItemCount: () => get().items.reduce((c, i) => c + i.quantity, 0),
      hasAlcohol: () => get().items.some((i) => i.isAlcohol),
      hasTobacco: () => get().items.some((i) => i.isTobacco),
      hasAgeRestrictedItems: () => get().items.some((i) => i.isAlcohol || i.isTobacco),
    }),
    { name: "labase-cart-web", storage: createJSONStorage(() => localStorage) }
  )
);
